import React, { useEffect, useState, useRef } from "react";
import styles from '../styles/TestPreparation.module.scss';
import WebinarEvents from "./WebinarEvents";
import Container from 'react-bootstrap/Container';
import Card from "react-bootstrap/Card";
import Row from 'react-bootstrap/Row';
import Breadcrumb from 'react-bootstrap/Breadcrumb';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Slider from "react-slick";
import CustomImage from "./CustomImage";
import FeaturedBlogs from "./FeaturedBlogs";
import StudentsAcheivents from "./StudentsAcheivement";
import Testimonial from "./Testimonial";
import SeveneasySteps from "./SeveneasySteps";
import format from "date-fns/format";
import OurExpert from "./OurExpertteam";
import fetchUtil from "../utils/fetchUtil";
import KcNewLatestUpdates from "./kcNewlatestupdates";
import { useRouter } from "next/router";
import { LazyLoadComponent } from "react-lazy-load-image-component";
import FaqComponent from "./PST/FrequentlyAskedQuestions";
import VideoTestimonials from "./PST/VideoTestimonials";
import { sliderSpeed } from "../utils/constants";
import { isFrappeOrJotFormClass } from "../utils/helpers";

const Testpreps: React.FC = (props: any) => {
  const router = useRouter();
  const sliderRef = useRef<Slider>(null);
  const [expertTeam, setExpertTeam] = useState<any>([])
  const [batchesData, setBatchesData] = useState<any>([])
  const settings = {
    dotsClass: styles.sliderDots,
    dots: true,
    infinite: true,
    speed: sliderSpeed.desktopSpeed,
    slidesToShow: 3,
    slidesToScroll: 3,
    initialSlide: 0,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          infinite: true,
          dots: false
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: true,
          dots: false,
          speed: sliderSpeed.mobileSpeed,
        }
      }
    ]
  };

  const expertsettings = {
    dotsClass: styles.sliderDots,
    dots: true,
    infinite: false,
    speed: sliderSpeed.desktopSpeed,
    slidesToShow: 4,
    slidesToScroll: 4,
    initialSlide: 0,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
          dots: true,
          speed: sliderSpeed.mobileSpeed,
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          speed: sliderSpeed.mobileSpeed,
        }
      }
    ]
  };

  const coursesettings = {
    dotsClass: styles.sliderDots,
    dots: true,
    infinite: false,
    speed: sliderSpeed.desktopSpeed,
    slidesToShow: 2,
    slidesToScroll: 2,
    initialSlide: 0,
    arrows: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: false,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          initialSlide: 2,
          infinite: false,
          dots: true,
          speed: sliderSpeed.mobileSpeed
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          infinite: false,
          dots: true,
          speed: sliderSpeed.mobileSpeed
        }
      }
    ]
  };

  useEffect(() => {
    fetchUtil(`${process.env.NEXT_PUBLIC_API_BASE_URL}/our-expert-teams`, 'GET', {}, '', false)
      .then((res) => setExpertTeam(res))
    fetchUtil(`${process.env.NEXT_PUBLIC_API_BASE_URL}/upcoming-batches?_sort=date:ASC`, 'GET', {}, '', false)
      .then((res) => setBatchesData(res))
  }, [])


  const formInstance = useRef<any>(null);

  const renderExamCards = (examData: any, sliderSettings: any, bgColor: string) => {
    return (
      <Row>
        <div id="batches-slider" className={styles.batchesSlider}>
          <Slider {...sliderSettings} className={styles.slider}>
            {
              examData?.length > 0 &&
              examData.map((exam: any) => {
                return (
                  <div className={styles.sliderCardDiv} key={exam.id}>
                    <Card className={styles.cardCust}>
                      <Card.Header style={{ backgroundColor: bgColor }} className={styles.cardheader}>{exam.testName}</Card.Header>
                      <Card.Body className={styles.cardBody}>
                        <ul>
                          {
                            exam.offerings.length > 0 &&
                            exam.offerings.map((offer: string, index: number) => <li key={index}>{offer}</li>)
                          }
                        </ul>
                        <div className={styles.footerBtn}>
                          <a href={exam.viewMoreLink} className={styles.viewMore} onClick={() => router.push(exam.viewMoreLink)}>View More</a>
                          <Button variant="primary" size="lg" className={`btn ${isFrappeOrJotFormClass(props?.pageData?.meta?.jotforms[0]?.jotformid)}`} 
                            onClick={()=> { !props?.pageData?.meta?.jotforms[0]?.jotformid && router.push(props?.pageData?.externalLink) }}>
                            Enroll Now 
                          </Button>
                        </div>
                      </Card.Body>
                    </Card>
                  </div>
                )
              })
            }
          </Slider>
        </div>
      </Row>
    )
  }

  return (
    <>
      <div className={styles.dynamicBg}>
        <Container>
          <div className={styles.mainSectionBg}>
            <Row>
              <Col xs={12} lg={6}>
                <div className="d-block d-sm-none text-center">
                  <div className="d-flex justify-content-center">
                    <Breadcrumb className={styles.mobileBreadCrum}>
                      <Breadcrumb.Item href="/" style={{ opacity: 0.5 }}>
                        Home
                      </Breadcrumb.Item>
                      <Breadcrumb.Item href="" >
                        Test Preparation
                      </Breadcrumb.Item>
                    </Breadcrumb>
                  </div>
                  <CustomImage src={props?.pageData?.mainImagePath} alt={props?.pageData?.mainImageAltTag} width={640} height={507} />
                </div>
                <div className={styles.mainContent}>
                  <div className="d-none d-sm-block text-center">
                    <Breadcrumb className={styles.mobileBreadCrum}>
                      <Breadcrumb.Item href="/" style={{ opacity: 0.5 }}>
                        Home
                      </Breadcrumb.Item>
                      <Breadcrumb.Item href="" >
                        Test Preparation
                      </Breadcrumb.Item>
                    </Breadcrumb>
                  </div>
                  <h1>{props?.pageData?.title}</h1>
                  <p>{props?.pageData?.description}</p>
                  <Button variant="primary" size="lg" className={`btn ${isFrappeOrJotFormClass(props?.pageData?.meta?.jotforms[0]?.jotformid)}`} 
                    onClick={()=> { !props?.pageData?.meta?.jotforms[0]?.jotformid && router.push(props?.pageData?.externalLink) }}>
                   { props?.pageData?.bannerBtn?.label|| ' Enquire Now'}
                  </Button>
                </div>
              </Col>
              <Col xs={12} lg={6} >
                <div className={styles.mainContent}>
                  <div className="d-none d-sm-block">
                    <div className={styles.contentImgGirl}>
                      <CustomImage src={props?.pageData?.mainImagePath} alt={props?.pageData?.mainImageAltTag} width={640} height={507} />
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
      </div >

      {/* Upcoming Batches */}
      {
        batchesData.length > 0 &&
        <div className={styles.upcomingBatches} >
          <Container>
            <Row className="text-center">
              <div >
                <h2>{props?.pageData?.batchesTitle}</h2>
              </div>
            </Row>
            <Row>
              <Col>
              
              <div className={styles.batchesSlider}>
                <Slider {...settings} ref={sliderRef} className={styles.slider}  >
                  {batchesData.map((batch: any) => {
                    return (
                        <div className={styles.sliderCardDiv} key={batch.id}>
                          <Card className={styles.cardCust}>
                            <LazyLoadComponent>
                              <Card.Img variant="top" src={batch?.testImagePath} alt={batch?.testImageAltTag} />
                            </LazyLoadComponent>
                            <Card.Body className={styles.cardBody}>
                              <Card.Text className={styles.textDate} >{batch?.testDesc}</Card.Text>
                              <Card.Title className={styles.subTitle}>Date: {format(new Date(batch.date), 'dd MMM yyyy')}</Card.Title>
                              {batch.time &&
                                <Card.Title className={styles.subTitle}>Time: {batch.time} </Card.Title>
                              }
                              <Card.Text className={styles.subTitle} >Duration : {batch?.duration}</Card.Text>
                              <Card.Text className={styles.subTitle} >Batch : {batch?.batch}</Card.Text>
                              <div className={styles.footerBtn}>  
                                 <a href={`/coaching/${batch.examType.replaceAll('_', '-')}`} onClick={() => router.push(`/coaching/${batch.examType.replaceAll('_', '-')}`)}  className={styles.viewMore}>
                                  View More
                                 </a>
                                <Button variant="primary" size="lg" 
                                        className={`btn ${isFrappeOrJotFormClass(props?.pageData?.meta?.jotforms[0]?.jotformid)}`}>
                                {batch?.button?.label || 'Enroll Now'}
                                </Button>
                              </div>
                            </Card.Body>
                          </Card>
                        </div>
                    )
                  })
                  }
                </Slider>
                <div className={styles.arrowsClass}>
                  <div className={styles.btcircle} onClick={() => sliderRef?.current?.slickPrev()}>
                    <CustomImage src='/new-images/left-arrow.svg' height={17} width={10} alt={"left-arrow"} />
                  </div>
                  <div className={styles.btcircle} onClick={() => sliderRef?.current?.slickNext()}>
                    <CustomImage src='/new-images/right-arrow.svg' height={17} width={10} alt={"right-arrow"} />
                  </div>
                </div>
              </div>
              </Col>
            </Row>
          </Container>
        </div>
      }

      {/* KC Academy */}
      <div className={styles.multiCountry}>
        <Container>
          <Row className="text-center">
            <div >
              <h2>{props?.pageData?.kcAcademy?.title}</h2>
            </div>
          </Row>
          <Row>
            <Col xs={12} lg={6} >
              <CustomImage src={props?.pageData?.kcAcademy?.newImagePath?.imageUrl} alt={props?.pageData?.kcAcademy?.newImagePath?.alt} width={490} height={444} />
            </Col>
            <Col xs={12} lg={6}>
              <div className={styles.multi_country_content}>
                <p>{props?.pageData?.kcAcademy?.description}</p>
                <ul>
                  {props?.pageData?.kcAcademy?.offerings?.length > 0
                    && props.pageData.kcAcademy.offerings.map((offer: string, index: number) => <li key={index}>{offer}</li>)}
                </ul>
                <div className={styles.buttonAlign}>
                  <Button variant="primary" size="lg" className={`btn ${isFrappeOrJotFormClass(props?.pageData?.meta?.jotforms[0]?.jotformid)}`} 
                    onClick={()=> { !props?.pageData?.meta?.jotforms[0]?.jotformid && router.push(props?.pageData?.externalLink) }}>
                   {props?.pageData?.kcAcademy?.bannerBtn?.label || 'Enroll Now'}
                  </Button>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      {/* Courses List */}
      <div className={styles.courseslist}>
        <Container>
          <Row>
            <Col xs={12} lg={6} className={styles.cardTop}>
              <Row className="text-center">
                <div >
                  <h3>For Bachelors</h3>
                </div>
              </Row>
              {props?.pageData?.bachelors?.length > 0 && renderExamCards(props?.pageData?.bachelors, coursesettings, '#FDC98D')}
            </Col>
            <Col xs={12} lg={6} className={styles.cardTop}>
              <Row className="text-center">
                <div >
                  <h3>For Masters</h3>
                </div>
              </Row>
              {props?.pageData?.masters?.length > 0 && renderExamCards(props?.pageData?.masters, coursesettings, '#FBBFB6')}
            </Col>
            <Col xs={12} lg={12} className={styles.cardTop}>
              <Row className="text-center">
                <div >
                  <h3>English Proficiency</h3>
                </div>
              </Row>
              {props?.pageData?.englishProficiency?.length > 0 && renderExamCards(props?.pageData?.englishProficiency, expertsettings, '#B8AAEE')}
            </Col>
            <Col xs={12} lg={12} className={styles.cardTop}>
              <Row className="text-center">
                <div>
                  <h3>{props.pageData.languagePrep.title}</h3>
                </div>
              </Row>
              {props?.pageData?.languagePrep?.languages?.length > 0 && renderExamCards(props.pageData.languagePrep.languages, expertsettings, '#B8AAEE')}
            </Col>
          </Row>
        </Container>
      </div>

      {/* Our expert Team */}
      {expertTeam.length > 0 && <OurExpert data={expertTeam} />}

      {/* Students Acheivements */}
      <StudentsAcheivents customClass={true} slug='our-students-achievements?type=coaching' />

      <Testimonial title='Our students love us' bgColor='#FFFFFF' slug={`student-testimonials?type=coaching&_limit=15&_sort=id:DESC`} />
      <div className={styles.achievements}>
        {props.pageData?.videoTestimonial &&
          <VideoTestimonials {...props.pageData.videoTestimonial} />}
      </div>
      <div className={styles.multiCountry}>
        <Container>
          <Row>
            <Col xs={12} lg={6} className={styles.tiups}>
              <div className={styles.multi_country_content}>
                <h2 className={styles.h2title}>1200+ Global University Tie Ups</h2>
                <h3>Study in the global university of your choice!</h3>
                <p>We value your career aspirations, which is why we map your preferences with the best that our global universities have to offer. Thousands of our students are pursuing their programs and aspirations in eminent universities globally and we welcome you to pursue yours!</p>
              </div>
            </Col>
            <Col xs={12} lg={6} className={styles.tiupImg}>
              <CustomImage src={props?.pageData?.multiCountry?.multiCountryImage?.imageUrl} alt={props?.pageData?.multiCountry?.multiCountryImage?.alt} width={430} height={565} />
            </Col>
          </Row>
        </Container>
      </div>

      <div >
        <WebinarEvents headingLevel={2}/>
      </div>
      <div className={styles.sevenStepbg}>
        <SeveneasySteps />
      </div>

      <div className={styles.testPrepLatestKcUpdates}>
        <KcNewLatestUpdates {...props} />
      </div>
      <div className={styles.homePageBlogs}>
        <FeaturedBlogs />
      </div>
      {props.pageData?.faq &&
        <FaqComponent {...props.pageData.faq} />}
      <div className={styles.studentFooter}>
        <Container>
          <Row>
            <Col >
              <div className={styles.session}>
                <Row>
                  <Col xs={12} lg={9}>
                    <div>
                      <h2>Start your Study Abroad Journey with KC </h2>
                      <p>Book a free in person or virtual counselling session with our experts now!</p>
                    </div>
                  </Col>
                  <Col xs={12} lg={3} className={styles.btCenter}>
                    <a href="/contact-us" className="btn btn-primary">Contact Us</a>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

    </>

  )
}

export default Testpreps;